module.exports = __webpack_public_path__ + "img/smart_logo_blue.39ef7866.png";